import {
	Field,
	PinInput as ArkPinInput,
	PinInputRootProps,
} from '@ark-ui/react'
import { inputCls } from '@qr-front/ui/components/Input'
import { fieldErrorCls } from '@qr-front/ui/components/InputField'
import { cn } from '@qr-front/ui/utils'
import { useEffect, useRef, useState } from 'react'

const Input = ({
	index,
	showCaret,
	inputClassName,
	isError,
}: {
	index: number
	preventInitialAutoFocus?: boolean
	showCaret?: boolean
	inputClassName?: string
	isError?: boolean
}) => {
	const [isFocused, setIsFocused] = useState(false)
	const isFirstRender = useRef(true)

	useEffect(() => {
		isFirstRender.current = false
	}, [])

	return (
		<div key={index} className="flex items-center justify-center">
			<ArkPinInput.Input
				index={index}
				placeholder={isFocused ? '' : '0'}
				onFocus={() => setIsFocused(true)}
				onBlur={() => setIsFocused(false)}
				tabIndex={isFirstRender.current ? -1 : undefined}
				className={cn(
					inputCls(isError),
					'type-heading-4 h-12 w-10 rounded-6 p-0 text-center',
					!showCaret && 'caret-transparent',
					inputClassName,
				)}
			/>
		</div>
	)
}

export const PinField = ({
	errorMessage,
	pinInputRootProps,
	showCaret,
	inputClassName,
	errorClassName,
}: {
	errorMessage: string
	pinInputRootProps: PinInputRootProps
	showCaret?: boolean
	inputClassName?: string
	errorClassName?: string
}) => {
	return (
		<Field.Root invalid={!!errorMessage}>
			<ArkPinInput.Root {...pinInputRootProps}>
				<ArkPinInput.Control className="flex justify-center gap-2 tablet:gap-4">
					{[0, 1, 2, 3, 4, 5].map((index) => (
						<Input
							key={index}
							index={index}
							showCaret={showCaret}
							inputClassName={inputClassName}
							isError={!!errorMessage}
						/>
					))}
				</ArkPinInput.Control>
				<ArkPinInput.HiddenInput />
			</ArkPinInput.Root>
			<Field.ErrorText asChild>
				<p className={cn(fieldErrorCls, 'mt-2', errorClassName)}>
					{errorMessage}
				</p>
			</Field.ErrorText>
		</Field.Root>
	)
}
